/**
 * Pre-seeded known video durations (in seconds) for instant render without network requests
 */
export const KNOWN_DURATIONS = {
  ylVwRn0cFTk: 1098,
  KL2tXE8w9PM: 3451,
  cumOoCZJUmQ: 1278,
  "OzyxhZk0-K8": 3513,
  wDCkGDq3b2o: 145,
  "7OKjUP6xsdA": 1446,
  u4n36SfXC3Y: 1204,
  "87b7FzdySXw": 1146,
  eo5mfg1yaKM: 1001,
  "3JNV09_r8O4": 128,
  nFjl4JJVYek: 178,
  "60RhzpMXLMY": 1097,
  "3nEVP11IzIU": 129,
  fKID2X1TARs: 4155,
  ykg927TYppU: 1127,
  "51E_pIXwnqM": 32,
  "b573Q-5XcQU": 183,
  yuEhQD2MWvE: 2017,
  rcFJmRgRfZM: 95,
  "851umdLOmXc": 169,
  EIDGKKEvihM: 67,
  "h4if9-H_5qE": 87,
  aLUzD6LhbXA: 1068,
  cJSLcVJqKsE: 70,
  mbcBMYYggTo: 234,
  apIO5O6RmGE: 60,
  mGSN1AtTDFc: 767,
  wStfI57BfDM: 73,
  i80gq0CCiNg: 70,
  "36J820Qhtwg": 1079,
  fzDDvfFv9hE: 71,
  "5EJL0OoQOXk": 657,
  uzL36EYLt_E: 497,
  m7j2zVTHc1E: 181,
  gGNU42y5L6k: 104,
  mKfUuudBb5g: 38,
  dLC0v7JQO3E: 554,
  apkaMDPqGAI: 60,
  bAjHonG9LuY: 93,
  CdlohfW02l4: 978,
  Sf6zAIktLUI: 3348,
  Peq9RLhO4qA: 825,
  yZW6lMG_gmQ: 44,
  "wF-vnnYYmOU": 91,
  qhnglB4Bvts: 45,
  ZRedwsH7KbI: 40,
  "7m4fNXuAg04": 121,
  QRISqwZxLKs: 38,
  tFJ2iHzbBsY: 70,
  AdiSoUF_YRI: 119,
  hV35r_kbBeE: 71,
  "11LdQNNVeBQ": 57,
  "4e5TwP-SO-8": 58,
  yrWkQaAzgLo: 97,
  BCYhBOfMAEg: 36,
  "R-lhSb5795Y": 34,
  yjCQzr7kDlU: 100,
  "jWv4KAX-qqc": 69,
  fAURuB3lAjU: 77,
  "1SJcHXh4Oig": 113,
  o1DfLyVPl18: 787,
  zLw08nIFdNM: 72,
};
